// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3iOlw","title":"Info_title__2Cwor","links":"Info_links__3dxzw","link":"Info_link__N4qKV","logo":"Info_logo__1ydSY"};